import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import API from '../../api';
import {
  CContainer,
  CSpinner,
  CAlert,
  CCard,
  CCardBody,
  CCardHeader,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from "@coreui/react";
import NeroLoader from '../../components/loaders/NeroLoader';

const ThistoryDetails = () => {
  const { userID } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTransactions = async () => {
      const user_id_nero = localStorage.getItem('user_id_nero');

      try {
        const response = await API.get(
          `payments?limit=100&offset=0&user_id_nero=${user_id_nero}`
        );
        if (response.status === 200) {
          setTransactions(response.data.payments);
        } else {
          setError(response.data.message || "Failed to fetch transactions");
        }
      } catch (error) {
        setError("An error occurred while fetching transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [userID]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="min-h-screen w-full top-up-page shop-area">
        <NeroLoader />
      </div>
    );
  }

  if (error) {
    return (
      <CContainer className="min-vh-100 d-flex justify-content-center align-items-center bg-all-container">
        <CAlert color="danger">{error}</CAlert>
      </CContainer>
    );
  }

  return (
    <div className="min-vh-100 bg-black bg-body-tertiary d-flex flex-column justify-content-center align-items-center padding-250">
        <CCard className='w-100 bg-blue' style={{borderRadius: 28}}>
        <CCardBody style={{justifyContent:'center', display:'flex', flexDirection:'column'}}>
        <Link
                          to="/"
                          className="flex items-center justify-center flex-row text-white"
                        >
                          <div className="logo-1">
                            <span>PYRO</span>
                          </div>
                          <div className="logo-2">
                            <span>GAMES</span>
                          </div>
                        </Link>
        <h1 style={{marginTop:'40px',marginBottom:'24px', color:'white', fontWeight:'bold', fontSize:'28px'}}>
          Riwayat Transaksi
          </h1>
          {transactions.length > 0 ? (
            <CAccordion>
              {transactions.map((transaction) => (
                <CAccordionItem key={transaction.id} itemKey={transaction.id}>
                  <CAccordionHeader style={{display:'flex', justifyContent:'space-between'}}>
                    <div style={{display:'flex', flexDirection:'column'}}>
                      <span>{` Transaction ID: ${transaction.transaction_id}`}</span>
                      <span>{` Total Amount: ${formatCurrency(transaction.amount)}`}</span>
                    </div>
                    <div>
                      <span>{transaction.payment_status}</span>
                    </div>
                  </CAccordionHeader>
                  <CAccordionBody>
                    <div><strong>Transaction ID: </strong> {transaction.transaction_id}</div>
                    <div><strong>Amount: </strong>{formatCurrency(transaction.amount)}</div>
                    <div><strong>Payment Method: </strong> {transaction.payment_method}</div>
                    <div><strong>Status: </strong> {transaction.payment_status}</div>
                    <div><strong>Date: </strong> {new Date(transaction.request_date).toLocaleString()}</div>
                    <div><strong>Game: </strong> {transaction.game_id}</div>
                    <div><strong>UserID: </strong> {transaction.user_id}</div>
                    {transaction.server_id && (
                      <div><strong>Server ID: </strong> {transaction.server_id}</div>
                    )}
                  </CAccordionBody>
                </CAccordionItem>
              ))}
            </CAccordion>
          ) : (
            <CAlert color="info">No transactions found</CAlert>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default ThistoryDetails;
